import { Component, Input, OnInit } from '@angular/core';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input() cardValue: (string);

  faCoffee = faCoffee;
  isCoffee: boolean; 

  ngOnInit() {
    if (this.cardValue === 'Koffie') {
      this.isCoffee = true;
    } else {
      this.isCoffee = false;
    }
  } 
}
